import { render, staticRenderFns } from "./SmsReportDetails.vue?vue&type=template&id=5575d926"
import script from "./SmsReportDetails.vue?vue&type=script&lang=js"
export * from "./SmsReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports